import { render, staticRenderFns } from "./OSCEInfo.vue?vue&type=template&id=13b7a0ae&scoped=true"
import script from "./OSCEInfo.vue?vue&type=script&lang=js"
export * from "./OSCEInfo.vue?vue&type=script&lang=js"
import style0 from "./OSCEInfo.vue?vue&type=style&index=0&id=13b7a0ae&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "13b7a0ae",
  null
  
)

export default component.exports